import { render, staticRenderFns } from "./PlayableScreenshot.vue?vue&type=template&id=4054e87c&scoped=true&"
import script from "./PlayableScreenshot.vue?vue&type=script&lang=js&"
export * from "./PlayableScreenshot.vue?vue&type=script&lang=js&"
import style0 from "./PlayableScreenshot.vue?vue&type=style&index=0&id=4054e87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4054e87c",
  null
  
)

component.options.__file = "PlayableScreenshot.vue"
export default component.exports